import api from "@/api";
import {
  AdminModel,
  AuthResponse,
  CommonModel,
  InitRequestModel,
  PageModel,
  PaginationModel,
  SignInModel,
} from "../types";

export default class AdminApi {
  static async list(
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ): Promise<PageModel<AdminModel>> {
    return await api.get(`admin/list`, options);
  }

  static async checkInit(): Promise<CommonModel> {
    return await api.get(`admin`);
  }

  static async checkInitPassword(data: InitRequestModel): Promise<CommonModel> {
    return await api.post(`admin`, data);
  }

  static async signup(data: AdminModel): Promise<AuthResponse> {
    return await api.post(`admin/signup`, data);
  }

  static async login(data: SignInModel): Promise<AuthResponse> {
    return await api.post(`auth/adminSignIn`, data);
  }
}
